import React from "react";

const CustomInput = (props) => {
    return (
        <div className="br-8 w-100">
            <input id={props.id} type={props.type} placeholder={props.placeholder} checked={props.checked}
                   onChange={props.onChange} required={props.required} min={props.min}
                   className="outline-none input-border p-1 br-8 w-100" value={props.value}/>
            {props.error && < div className="fc-red fs-14 py-1">{props.error}</div>}
        </div>
    );
}

export default CustomInput;
